class ShoppableImageCustom extends HTMLElement {
  constructor() {
    super();
    this.hotspots = this.querySelectorAll(".image-hotspot-custom");
    this.swiper = null;
    this.swiperButtonNext = this.querySelector(".swiper-button-next");
    this.swiperButtonPrev = this.querySelector(".swiper-button-prev");
  }

  connectedCallback() {
    this.initHotspots();
    this.initSwiper();
  }

  initHotspots() {
    this.hotspots.forEach((hotspot) => {
      if (hotspot.dataset.index === "0") {
        hotspot.classList.add("is-active");
      }
      hotspot.addEventListener("click", (e) => {
        e.preventDefault();
        const index = parseInt(hotspot.dataset.index);

        if (this.swiper) {
          this.swiper.slideTo(index);
        }
      });
    });
  }

  initSwiper() {
    const swiperElement = this.querySelector(".shoppable-image__swiper");
    if (!swiperElement) return;

    this.swiper = new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 10,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: this.swiperButtonNext,
        prevEl: this.swiperButtonPrev,
      },
      on: {
        slideChange: () => {
          this.updateActiveHotspot();
        },
      },
    });
  }

  updateActiveHotspot() {
    const activeIndex = this.swiper.activeIndex;
    this.hotspots.forEach((hotspot) => {
      const index = parseInt(hotspot.dataset.index);
      if (index === activeIndex) {
        hotspot.classList.add("is-active");
      } else {
        hotspot.classList.remove("is-active");
      }
    });
  }
}

customElements.define(
  "shoppable-image-controller-custom",
  ShoppableImageCustom
);
